import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { CalendarDays } from 'lucide-react';
export const ProofSection = () => {
  return <Section variant="navy" data-id="element-138">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-139">
        <div className="bg-navy-light p-8 md:p-12 rounded-2xl border-l-4 border-gold shadow-xl relative overflow-hidden" data-id="element-140">
          {/* Decorative background element */}
          <div className="absolute top-0 right-0 -mt-8 -mr-8 text-gold/5" data-id="element-141">
            <CalendarDays className="w-48 h-48" data-id="element-142" />
          </div>

          <div className="relative z-10" data-id="element-143">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-cream" data-id="element-144">
              Lo que cambia en <span className="text-gold" data-id="element-145">7 días</span>:
            </h3>
            <p className="text-lg md:text-xl text-cream-muted leading-relaxed mb-6" data-id="element-146">
              Pasarás de despertarte en estado de alerta a tener un protocolo de
              defensa. El nudo en tu pecho no desaparecerá por arte de magia,
              pero tendrás la herramienta para desatarlo cada vez que aparezca.
            </p>
            <p className="text-xl font-serif italic text-gold" data-id="element-147">
              Recuperando el control de tus mañanas y tus noches.
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};